// @ts-nocheck
import _ from 'lodash';
import React, { Component } from 'react';
import { inject, observer } from "../../../../../stores/mobx-compat";

import Modal, { ModalActions } from '../../../../ui/Modal';
import FormGroup from '../../../../ui/FormGroup';
import Input from '../../../../ui/Input';
import Tooltip from '../../../../ui/Tooltip';
import FileUpload from '../../../../ui/FileUpload';
import { MailIcon, UploadIcon, TrashIcon, InfoIcon } from '../../../../ui/icons';

class EmailModal extends Component {
  defaultState = {
    name: '', template: '', description: '', tag: '', comment: '',
    to: this.props.store.auth.user.email || '',
    from: `test@${this.props.store.emailManagement.activeEmailDomainName}`,
    subject: '', text: '', formData: '',
    files: [],
  };

  state = this.defaultState;

  componentDidUpdate(prevProps) {
    const { templateName = '' } = this.props;
    if (prevProps.templateName !== templateName) {
      this.setState({ name: templateName || '', subject: `TEST - ${templateName}` });
    }
  }

  handle = (name, value) => this.setState({ [name]: value });

  cancel = () => {
    this.setState(this.defaultState);
    this.props.onClose();
  }

  validateFormData() {
    try {
      if (this.state.formData !== '') JSON.parse(this.state.formData);
    } catch (e) { return false; }
    return true;
  }

  field = (name, label = '', extra = null) => (
    <FormGroup key={name} label={(
      <span className="inline-flex items-center gap-1.5">
        {label || _.startCase(name)}
        {extra}
      </span>
    )}>
      <Input
        placeholder={label}
        value={this.state[name] || ''}
        onChange={(e) => this.handle(name, e.target.value)}
      />
    </FormGroup>
  );

  render() {
    const { type } = this.props;
    const em = this.props.store.emailManagement;

    if (type === 'uploadTemplates') {
      return (
        <Modal
          open={this.props.open}
          onClose={this.cancel}
          size="lg"
          title="Upload email templates"
          icon={UploadIcon}
          actions={(
            <ModalActions
              onCancel={this.cancel}
              onConfirm={async () => { await em.uploadTemplates(this.state.files); this.cancel(); }}
              confirmLabel="Upload"
              confirmLoading={em.loading.uploadTemplates}
              confirmDisabled={this.state.files.length === 0}
            />
          )}
        >
          <FileUpload
            files={this.state.files}
            onChange={(files) => this.setState({ files })}
            accept=".html,.htm,.hbm,.handlebars"
            maxFiles={10}
            maxSize={1024 * 1024}
            note="MAX 10 · ≤1024KB · .html .htm .hbm .handlebars"
          />
        </Modal>
      );
    }

    if (type === 'deleteTemplate') {
      return (
        <Modal
          open={this.props.open}
          onClose={this.cancel}
          size="sm"
          title="Delete template?"
          icon={TrashIcon}
          actions={(
            <ModalActions
              onCancel={this.cancel}
              onConfirm={async () => { await em.deleteTemplate(this.props.templateName); this.cancel(); }}
              confirmLabel="Delete"
              confirmVariant="danger"
              confirmLoading={em.loading.deleteTemplate}
            />
          )}
        >
          <p className="m-0 text-[13px] text-mov-ink-soft">
            <b className="text-mov-ink">{this.props.templateName}</b> will be deleted permanently.
          </p>
        </Modal>
      );
    }

    if (type === 'sendTestEmail') {
      return (
        <Modal
          open={this.props.open}
          onClose={this.cancel}
          size="md"
          title="Send test email"
          icon={MailIcon}
          actions={(
            <ModalActions
              onCancel={this.cancel}
              onConfirm={async () => {
                if (!this.validateFormData()) {
                  this.props.store.failure('Badly formatted JSON!');
                  return;
                }
                await em.sendTestEmail(_.pick(this.state, ['name', 'to', 'from', 'subject', 'text', 'formData']));
                this.cancel();
              }}
              confirmLabel="Send test"
              confirmLoading={em.loading.sendTestEmail}
            />
          )}
        >
          {['name', 'to', 'from', 'subject', 'text'].map((n) => this.field(n))}
          {this.field('formData', 'Form Data', (
            <Tooltip content="Optional: provide data as JSON">
              <span className="text-mov-ink-mute"><InfoIcon size={12} /></span>
            </Tooltip>
          ))}
        </Modal>
      );
    }

    if (type === 'addTemplate') {
      return (
        <Modal
          open={this.props.open}
          onClose={this.cancel}
          size="lg"
          title="Add email template"
          icon={MailIcon}
          actions={(
            <ModalActions
              onCancel={this.cancel}
              onConfirm={async () => {
                await em.addTemplate(_.pick(this.state, ['name', 'template', 'description', 'tag', 'comment']));
                this.cancel();
              }}
              confirmLabel="Add"
              confirmLoading={em.loading.addTemplate}
            />
          )}
        >
          {[
            ['name', 'Template name'],
            ['template', 'Template HTML'],
            ['description', 'Description'],
            ['tag', 'Tag'],
            ['comment', 'Comment'],
          ].map(([n, l]) => this.field(n, l))}
        </Modal>
      );
    }

    return null;
  }
}

export default inject('store')(observer(EmailModal));
